"use client";

import analytics from "./analytics";

const write_key = process.env.NEXT_PUBLIC_CIO_PIPELINE_KEY as string;

// used in shopsite to load analytics by default
export default function CustomerIOAnalytics() {
  analytics.load({ writeKey: write_key });

  return null;
}
